<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Interconsultas</h4>
        </div>
        <div class="col-1">
          <button
            class="btn-help"
            type="button"
            title="Abrir ayuda"
            @click="showModalHelp = true"
            aria-label="Abrir ayuda de interconsultas"
          >
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Interconsultas">
      <AyudaInterconsulta />
    </Modal>

    <hr>

    <DataTable
      :data="interconsultas"
      :columns="columnas"
      idField="idInterconsulta"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="false"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay interconsultas disponibles."
      @refresh="getDataPaginaTodos()"
    >
      <!-- Celda: Fecha -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>

      <!-- Celda: Estado con color -->
      <template #cell-estadoInter="{ row }">
        <span class="badge-estado" :class="getClassForEstadoInter(row.estadoInter)">
          {{ row.estadoInter }}
        </span>
      </template>

      <!-- Acciones por fila -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-warning"
          @click.stop="abrirModalEditar(row.idInterconsulta)"
          title="Resumen"
        >
          <span class="material-symbols-outlined" style="font-size:14px">summarize</span>
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.stop="abrirEditar(row.idAtencion, row.idInterconsulta)"
          title="Detalles"
        >
          <span class="material-symbols-outlined" style="font-size:14px">open_in_new</span>
        </button>
        <!-- Formulario 007 - Solicitud -->
        <button
          class="btn btn-sm btn-outline-success"
          @click.stop="abrirDocumento(row.idInterconsulta, 'solicitud')"
          title="Formulario 007 - Solicitud"
        >
          <span class="material-symbols-outlined" style="font-size:14px">quick_reference_all</span>
        </button>
        <!-- Formulario 007 - Informe -->
        <button
          class="btn btn-sm btn-outline-success"
          @click.stop="abrirDocumento(row.idInterconsulta, 'informe')"
          title="Formulario 007 - Informe"
          :disabled="row.estadoInter !== 'FINALIZADA'"
        >
          <span class="material-symbols-outlined" style="font-size:14px">quick_reference_all</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal resumen interconsulta -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="modalInterconsultaLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalInterconsultaLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2" v-for="campo in camposModal" :key="campo.label">
              <div class="col-3">
                <label class="fw-bold">{{ campo.label }}</label>
              </div>
              <div class="col-9">
                <span
                  class="form-control-plaintext"
                  :style="campo.upper ? 'text-transform:uppercase' : ''"
                >
                  {{ campo.valor }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!-- Formulario 007 - Solicitud -->
<Modal v-model:modelValue="showModalSolicitud" title="Formulario 007 - Solicitud">
  <DocVerFirmarGuardar :idReporte="3" :idDocumento="idInterconsultaDocumento" />
</Modal>

<!-- Formulario 007 - Informe -->
<Modal v-model:modelValue="showModalInforme" title="Formulario 007 - Informe">
  <DocVerFirmarGuardar :idReporte="4" :idDocumento="idInterconsultaDocumento" />
</Modal>

    <Footer />
  </div>
</template>

<script>
import Layout             from '@/components/Layout.vue'
import Footer             from '@/components/Footer.vue'
import AyudaInterconsulta from '@/views/ayuda/AyudaInterconsulta.vue'
import DataTable          from '@/components/DataTable.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue'
import dateFormat         from '@/modules/dateFormat.js'
import api                from '@/services/api'
import { openModal }      from '@/modules/modalHelper.js'

export default {
  name: 'Interconsultas',
  components: { Layout, Footer, AyudaInterconsulta, DataTable, DocVerFirmarGuardar },
  data() {
    return {
      interconsultas:           [],
      datoInterconsulta:        {},
      titulo:                   '',
      modalWindow:              true,
      showModalHelp:            false,
      showModalSolicitud:       false,
      showModalInforme:         false,
      idInterconsultaDocumento: null,
      p_idMedico:        0,
      columnas: [
        { field: 'fechaReg',       label: 'Fecha Reg.' },
        { field: 'estadoInter',    label: 'Estado' },
        { field: 'medicoAtencion', label: 'Médico' },
        { field: 'paciente',       label: 'Paciente' },
      ],
    }
  },
  computed: {
    camposModal() {
      const d = this.datoInterconsulta
      return [
        { label: 'Id. Interconsulta', valor: d.idInterconsulta },
        { label: 'Fecha Atención',    valor: this.getFormattedDate(d.atencionFechaReg) },
        { label: 'Estado',            valor: d.estadoInter },
        { label: 'Médico',            valor: d.medicoAtencion },
        { label: 'Motivo',            valor: d.motivo, upper: true },
        { label: 'Cuadro',            valor: d.cuadro, upper: true },
      ]
    },
  },
  mounted() {
    this.p_idMedico = window.sessionStorage.getItem('idMedico')
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getDataPaginaTodos()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    getDataPaginaTodos() {
      if (!this.p_idMedico) return
      api.get(`/vwinterconsultas/idmedico/${this.p_idMedico}`)
        .then(response => { this.interconsultas = response.data.reverse() })
        .catch(error   => console.error('Error al obtener interconsultas:', error))
    },
    abrirModalEditar(idInterconsulta) {
      this.modalWindow = true
      if (idInterconsulta) {
        api.get(`/vwinterconsultas/destino/${idInterconsulta}`)
          .then(resp => { this.datoInterconsulta = resp.data })
      }
      openModal('ventanaModal')
      this.titulo = 'Resumen de la Interconsulta'
    },
    abrirEditar(idAtencion, idInterconsulta) {
      if (idInterconsulta) {
        this.$router.push(`/interconsultadestinoform/${idAtencion}/${idInterconsulta}`)
      }
    },
    getClassForEstadoInter(estado) {
      return {
        'SOLICITADA': 'solicitada',
        'ASIGNADA':   'asignada',
        'PROCESO':    'proceso',
        'RECHAZADA':  'rechazada',
        'FINALIZADA': 'finalizada',
      }[estado] || ''
    },
    abrirDocumento(idInterconsulta, tipo) {
      this.idInterconsultaDocumento = idInterconsulta
      if (tipo === 'solicitud') this.showModalSolicitud = true
      else                      this.showModalInforme   = true
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.busqueda-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}
.busqueda-campo {
  display: flex;
  flex-direction: column;
  min-width: 130px;
  flex: 1;
}
.busqueda-campo--lg { flex: 3 1 260px; }
.busqueda-bar .form-label {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #6c757d;
}
.btn-icono {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  padding: 6px 12px;
  flex-shrink: 0;
}
.btn-label { font-size: 14px; }
@media (max-width: 576px) {
  .busqueda-campo,
  .busqueda-campo--lg { flex: 1 1 100%; }
  .btn-icono { width: 100%; }
}
</style>